const box = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export default { box };
